// helper to capitalize strings
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/inline-style-prefixer/lib/utils/capitalizeString.js
 ** module id = 1315
 ** module chunks = 0
 **/